import { useEffect, useRef, useState } from 'react'
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams
} from 'react-router-dom'
import Input from './Input.js'
import { use } from '../Helpers.js'
import ValidateInput from '../ValidationDefaults.js'

function FormModal ({ moduleUrl, formSettings = [], onSubmit }) {
  const [forms, setForms] = useState()
  const [searchParams, setSearchParams] = useSearchParams()
  const [formLists, setFormLists] = useState({})
  const { id, formName } = useParams()
  const location = useLocation()
  const [activeFormIndex, setActiveFormIndex] = useState()
  const [mode, setMode] = useState(null)
  const [formSubmitAction, setFormSubmitAction] = useState()
  const [formData, setFormData] = useState({})
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [alertBoxMessage, setAlertBoxMessage] = useState({})
  const [validation, setValidation] = useState({})

  const formRef = useRef()

  const defineMode = _id => {
    let _mode = null
    if (![null, undefined, ''].includes(_id)) {
      if (_id === 'add') {
        _mode = 'add'
      } else if (!isNaN(_id)) {
        _mode = 'edit'
      }
    }
    return _mode
  }

  const collectFormLists = async (_formSettings, _activeFormIndex) => {
    if (!_formSettings?.[_activeFormIndex]?.formLists) return {}

    let _formLists = {}
    for (const key of Object.keys(_formSettings[_activeFormIndex].formLists)) {
      const listSource = _formSettings[_activeFormIndex].formLists[key]
      if (typeof listSource === 'function') {
        if (listSource.length > 0) {
          _formLists[key] = await listSource(id)
        } else {
          _formLists[key] = await listSource()
        }
      }
    }
    setFormLists({ ..._formLists })
  }

  useEffect(() => {
    let _mode = defineMode(id)
    setMode(_mode)
    if (_mode != null) {
      setOpen(true)
      if (_mode === 'edit' && ![null, undefined, ''].includes(formName)) {
        let _activeFormIndex = formSettings.findIndex(f => f.name == formName)
        setActiveFormIndex(_activeFormIndex)
      } else {
        setActiveFormIndex(0)
      }
    }
  }, [id, formName])

  useEffect(() => {
    if (defineMode(id) == 'edit' && ![null, undefined, ''].includes(formName)) {
      let _activeFormIndex = formSettings.findIndex(f => f.name == formName)
      setActiveFormIndex(_activeFormIndex)
    }
  }, [formName])

  useEffect(() => {
    if (formSettings != null) {
      setForms(formSettings)
    }
  }, [])

  // when forms/index/mode ready, bind the correct submit action
  useEffect(() => {
    if (forms && !isNaN(activeFormIndex) && mode) {
      let activeForm = forms?.[activeFormIndex]
      setFormSubmitAction(() => activeForm?.actions?.[mode])
      setValidation({})
    }
  }, [forms, activeFormIndex, mode])

  useEffect(() => {
    if (!isNaN(activeFormIndex)) {
      if (forms) {
        collectFormLists(formSettings, activeFormIndex)
      }
    }
  }, [activeFormIndex,loading])

  useEffect(() => {
    //get data from server and save
    const retrieveFormData = async formMode => {
      let _formData = {}
      if (formMode === 'edit' && activeFormIndex != null) {
        const result = await forms[activeFormIndex]?.actions.get(id)
        if (result?.success) {
          let resultData = result.data
          forms[activeFormIndex]?.fields.forEach(f => {
            if (f.fieldName != undefined) {
              ;[]
                .concat(f.type == 'input-group-section' ? [...f.fields] : [f])
                .map(_f => {
                  if (
                    [null, undefined, ''].includes(resultData[_f.fieldName])
                  ) {
                    _formData[_f.fieldName] = _f.defaultValue
                  } else _formData[_f.fieldName] = resultData[_f.fieldName]
                })
            }
          })
        }
      }
      setFormData(() => _formData)
    }
    retrieveFormData(mode)
  }, [mode, activeFormIndex])

  //render basic field, section or table
  const renderFormFields = (form, idx) => {
    return (
      <form
        className='form row'
        ref={formRef}
        name={form.name}
        onSubmit={e => submitForm(e)}
      >
        {!loading &&
          forms[idx]?.fields.map((field, index) => {
            if (field.type == 'input-group-row') {
              return !loading && renderTable(field)
            } else if (field.type == 'input-group-section') {
              return renderSection(field)
            } else if (field.type == 'info-table') {
              return renderInfoTable(field)
            } else {
              let eventHandlers = [...(field.eventHandlers || [])]
              if (field.effects?.length > 0) {
                field.effects?.forEach(effect => {
                  if (effect.type == 'valueChange') {
                    eventHandlers.push({
                      type: 'change',
                      handler: e => {
                        let parent = document.forms.namedItem(form.name)

                        if (parent) {
                          let element = parent.querySelector(
                            `[name="${effect.fieldName}"]`
                          )

                          if (typeof effect.checkCondition == 'function') {
                            element.value = effect.checkCondition(
                              e.target.value
                            )
                          }
                        }
                      }
                    })
                  } else if (effect.type == 'disableTable') {
                    eventHandlers.push({
                      type: 'change',
                      handler: e => {
                        let parent = document.forms.namedItem(form.name)
                        if (parent) {
                          let element = parent.querySelector(
                            `[data-name="${effect.fieldName}"]`
                          )
                          if (typeof effect.checkCondition == 'function') {
                            if (effect.checkCondition(e.target.checked)) {
                              element.classList.add('disabled')
                            } else {
                              element.classList.remove('disabled')
                            }
                          }
                        }
                      }
                    })
                  } else if (effect.type == 'disableField') {
                    eventHandlers.push({
                      type: 'change',
                      handler: e => {
                        let parent = document.forms.namedItem(form.name)
                        if (parent) {
                          let element = parent.querySelector(
                            `[name="${effect.fieldName}"]`
                          )
                          if (typeof effect.checkCondition == 'function') {
                            if (effect.checkCondition(e.target.checked)) {
                              element.disabled = true
                            } else {
                              element.disabled = false
                            }
                          }
                        }
                      }
                    })
                  }
                })
              }
              return (
                ((field.data === 'string' &&
                  ['select', 'select-multiple'].includes(field.type) &&
                  formLists) ||
                  field.data !== 'string') && (
                  <Input
                    key={`${field.fieldName}#${index}`}
                    fieldName={field.fieldName}
                    required={field.validationRules?.includes('required')}
                    disabled={field.disabled}
                    label={field.label}
                    placeholder={field.placeholder}
                    type={field.type}
                    multiple={field.multiple}
                    defaultSelectOptions={field.defaultSelectOptions}
                    col={field.col}
                    acceptNullValue={field.acceptNullValue}
                    data={formLists[field.data]}
                    dataSource={field.dataSource}
                    value={loadFieldValueFromSavedFormData(field)}
                    eventHandler={eventHandlers}
                    validationResult={validation?.[field.fieldName]}
                    loading={loading}
                  />
                )
              )
            }
          })}
      </form>
    )
  }

  //rendering section
  const renderSection = section => {
    return (
      <div key={`${section.label}`} className='input-group-section-container'>
        <p className='group-label'>{section.label}</p>
        <div name={section.fieldName} className='input-group-section row'>
          {section.fields.map((field, index) => (
            <Input
              key={`${field.fieldName}#${index}`}
              fieldName={field.fieldName}
              label={field.label}
              disabled={field.disabled}
              defaultSelectOptions={field.defaultSelectOptions}
              placeholder={field.placeholder}
              type={field.type}
              col={field.col}
              data={field.dataSource ? null : field.data}
              dataSource={field.dataSource}
              value={
                loadFieldValueFromSavedFormData(field) || field.defaultValue
              }
              eventHandler={field.eventHandlers}
              validationResult={field.validationResult}
            />
          ))}
        </div>
      </div>
    )
  }

  //adding row to the table
  const addTableRow = tableName => {
    setFormData(prevState => {
      const currentRows = prevState[tableName] || []
      const newRows = [...currentRows, {}]
      return {
        ...prevState,
        [tableName]: newRows
      }
    })
  }

  //rendering table
  const renderTable = field => {
    let rowNumber = 0
    let columnClassName = ''
    let col = field.col
    if (col) {
      Object.keys(col).forEach(key => {
        if (col[key] != 0) {
          columnClassName +=
            key == 'default'
              ? ' col-' + col[key]
              : ' col-' + key + '-' + col[key]
        } else {
          columnClassName += key == 'default' ? ' d-none' : ' d-none'
        }
      })
    }
    return (
      <div key={field.fieldName} className={`${columnClassName}`}>
        <div
          key={field.fieldName}
          className={`input-group-row-container ${field.className}`}
          disabled={field.disabled ? true : false}
          data-name={field.fieldName}
        >
          <p className='group-label'>{field.label}</p>
          <div className='scroll-container'>
            <table
              style={{ width: 90 * field.rowFields.length + 'px' }}
              className='input-group-row-table'
              data-table={field.fieldName}
            >
              <thead>
                <tr className=''>
                  <th>#</th>
                  {field.rowFields.map((f, fieldIndex) => {
                    return (
                      <th
                        key={f.fieldName + fieldIndex}
                        width={f.columnWidth}
                        style={Object.assign(
                          f.style || {},
                          f.type == 'hidden' ? { display: 'none' } : {}
                        )}
                      >
                        {f.label}
                      </th>
                    )
                  })}
                </tr>
              </thead>
              {formData[field.fieldName]?.length != 0 && (
                <tbody name={field.fieldName}>
                  {[
                    ...new Array(formData[field.fieldName]?.length || 0).fill(
                      field.rowFields
                    )
                  ].map((row, rowIndex) => {
                    if (formData[field.fieldName][rowIndex]?.id == 0) {
                      return false
                    }
                    rowNumber++
                    let _rowStyle = field.rowStyleRules
                      ? Object.assign(
                          {},
                          ...field.rowStyleRules?.map(rs => {
                            return rs.getStyleRule(
                              formData[field.fieldName][rowIndex][rs.fieldName]
                            )
                          })
                        )
                      : {}

                    return (
                      <tr
                        className=''
                        data-input-group-row
                        key={`${field.fieldName}#${rowIndex}`}
                        style={_rowStyle}
                        data-index={formData[field.fieldName][rowIndex]['id']}
                      >
                        <td style={{ width: '20px', fontSize: '10px' }}>
                          {rowNumber}
                        </td>

                        {row.map((rowField, index) => {
                          let _id =
                            formData[field.fieldName]?.[rowIndex]?.['id']
                          let params = {}
                          if (rowField.parameters?.length > 0) {
                            rowField.parameters.forEach(rp => {
                              let _splitted = rp.split(':')
                              if (_splitted.length == 2) {
                                let _source = _splitted[0]
                                let _parameterName = _splitted[1]
                                if (_source == 'global') {
                                  params[_parameterName] =
                                    formData[_parameterName]
                                } else if (_source == 'line') {
                                  params[_parameterName] =
                                    formData[field.fieldName]?.[rowIndex]?.[
                                      _parameterName
                                    ]
                                }
                              } else {
                                params[rp] =
                                  formData[field.fieldName]?.[rowIndex]?.[rp]
                              }
                            })
                          }
                          if (rowField.type === 'operations') {
                            return (
                              <td
                                key={rowField.fieldName + index}
                                className='operations'
                              >
                                <div className='operations-container'>
                                  {rowField?.operations?.length > 0 &&
                                    rowField.operations?.map((o, index) => {
                                      if (
                                        Array.isArray(o.parameters) &&
                                        o.parameters?.length > 0
                                      ) {
                                        o.parameters.forEach(rp => {
                                          let _splitted = rp.split(':')
                                          if (_splitted.length == 2) {
                                            let _source = _splitted[0]
                                            let _parameterName = _splitted[1]
                                            if (_source == 'global') {
                                              params[_parameterName] =
                                                formData[_parameterName]
                                            } else if (_source == 'line') {
                                              params[_parameterName] =
                                                formData[field.fieldName]?.[
                                                  rowIndex
                                                ]?.[_parameterName]
                                            }
                                          } else {
                                            params[rp] =
                                              formData[field.fieldName]?.[
                                                rowIndex
                                              ]?.[rp]
                                          }
                                        })
                                      }

                                      if (o.type == 'delete') {
                                        let disablingMessage = ''
                                        let _disabled =
                                          o?.disablingConditions?.some(dc => {
                                            disablingMessage +=
                                              dc.description + '\n'
                                            return dc?.checkCondition(
                                              formData[field.fieldName][
                                                rowIndex
                                              ][dc.fieldName]
                                            )
                                          })
                                        return (
                                          <span
                                            key={o.name + index}
                                            title={
                                              _disabled
                                                ? disablingMessage
                                                : null
                                            }
                                            className={`operation operation-delete ${
                                              _id < 0 ? 'cancel' : ''
                                            } ${_disabled ? 'disabled' : ''}`}
                                            onClick={() => {
                                              if (_disabled) {
                                                return false
                                              }
                                              if (_id < 0) {
                                                let _formData = formData
                                                _formData[field.fieldName][
                                                  rowIndex
                                                ]['id'] = -1 * _id
                                                setFormData({ ..._formData })
                                                return false
                                              } else if (
                                                [null, undefined, ''].includes(
                                                  _id
                                                )
                                              ) {
                                                let _formData = formData
                                                _formData[field.fieldName][
                                                  rowIndex
                                                ]['id'] = 0
                                                setFormData({ ..._formData })
                                                return false
                                              }
                                              let _formData = formData
                                              _formData[field.fieldName][
                                                rowIndex
                                              ]['id'] = -1 * _id
                                              setFormData({ ..._formData })
                                            }}
                                          >
                                            <Link
                                              className={
                                                _id < 0 ? 'delete' : ''
                                              }
                                            >
                                              <img
                                                className='operation-icon'
                                                style={o.iconStyle}
                                                src={o.icon}
                                              />
                                            </Link>
                                          </span>
                                        )
                                      } else if (o.type == 'command') {
                                        let disablingMessage = ''
                                        let _disabled =
                                          o.disablingConditions?.some(dc => {
                                            disablingMessage +=
                                              dc.description + '\n'
                                            return dc.checkCondition(
                                              formData[field.fieldName][
                                                rowIndex
                                              ][dc.fieldName]
                                            )
                                          })
                                        let commandParams = new URLSearchParams(
                                          {
                                            requestType: 'command',
                                            commandName: o.name,
                                            parameters: JSON.stringify(params),
                                            token: 'xy103'
                                          }
                                        )
                                        return (
                                          <Link
                                            to={''}
                                            key={o.name + index}
                                            title={
                                              _disabled
                                                ? disablingMessage
                                                : null
                                            }
                                            onClick={e => {
                                              if (_disabled) {
                                                return false
                                              }
                                              e.preventDefault()
                                              setSearchParams(commandParams)
                                            }}
                                            className={`operation operation-command ${
                                              _disabled || _id < 0
                                                ? 'disabled'
                                                : ''
                                            }`}
                                          >
                                            {o.iconType == 'path' ? (
                                              <img
                                                style={o.iconStyle}
                                                className='operation-icon'
                                                src={o.icon}
                                              />
                                            ) : (
                                              <span
                                                style={o.iconStyle}
                                                className='operation-icon'
                                              >
                                                {o.icon}
                                              </span>
                                            )}
                                          </Link>
                                        )
                                      }
                                    })}
                                </div>
                              </td>
                            )
                          } else {
                            let _disabled = false
                            if (rowField.disablingConditions?.length > 0) {
                              _disabled = rowField.disablingConditions.some(
                                dc => {
                                  return dc.checkCondition(
                                    formData[field.fieldName]?.[rowIndex]?.[
                                      dc.fieldName
                                    ]
                                  )
                                }
                              )
                            }
                            return (
                              <td
                                key={`${rowField.fieldName}#${index}`}
                                disabled={rowField.disabled}
                                style={Object.assign(
                                  rowField.style || {},
                                  rowField.type == 'hidden'
                                    ? { display: 'none' }
                                    : {}
                                )}
                              >
                                <Input
                                  fieldName={rowField.fieldName}
                                  searchFieldName={rowField.searchFieldName}
                                  disabled={rowField.disabled || _disabled}
                                  placeholder={rowField.placeholder}
                                  type={rowField.type}
                                  multiple={field.multiple}
                                  defaultValue={rowField.defaultValue}
                                  value={
                                    loadFieldValueFromSavedFormData(
                                      rowField,
                                      rowIndex,
                                      field.fieldName
                                    ) ?? rowField.defaultValue
                                  }
                                  defaultSelectOptions={
                                    rowField.defaultSelectOptions
                                  }
                                  data={
                                    typeof rowField.data == 'string'
                                      ? formLists[rowField.data]
                                      : typeof rowField.data == 'function'
                                      ? formLists[rowField.data(params)]
                                      : rowField.data
                                  }
                                  style={rowField.style}
                                  parameters={params}
                                  dataSource={
                                    rowField.dataSource
                                      ? async params =>
                                          await rowField.dataSource(params)
                                      : null
                                  }
                                  eventHandler={rowField.eventHandlers}
                                  validationResult={validation[field.fieldName]?.find(r=>r.rowIndex==rowIndex)?.[rowField.fieldName]}
                                />
                              </td>
                            )
                          }
                        })}
                      </tr>
                    )
                  })}
                </tbody>
              )}
              {formData[field.fieldName]?.length == 0 && (
                <tfoot>
                  <tr>
                    <td className='no-data' colSpan='100'>
                      Məlumat yoxdur
                    </td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
          {field.multipleRows && field.addRowPermission && (
            <div className='button-group-row'>
              <div className='row'>
                <Input
                  type='button'
                  label='+ Yeni Sətir'
                  className='add-row'
                  col={{ sm: 12 }}
                  style={{ display: 'block' }}
                  eventHandler={{
                    type: 'click',
                    handler: () =>
                      addTableRow(field.fieldName, formData[field.fieldName])
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }

  const renderInfoTable = field => {
    let rowNumber = 0
    let columnClassName = ''
    let col = field.col
    if (col) {
      Object.keys(col).forEach(key => {
        if (col[key] != 0) {
          columnClassName +=
            key == 'default'
              ? ' col-' + col[key]
              : ' col-' + key + '-' + col[key]
        } else {
          columnClassName += key == 'default' ? ' d-none' : ' d-none'
        }
      })
    }
    return (
      <div key={field.fieldName} className={`${columnClassName}`}>
        <div
          key={field.fieldName}
          className={`info-table-container ${field.className}`}
          data-name={field.fieldName}
        >
          <p className='group-label'>{field.label}</p>
          <table className='info-table' data-table={field.fieldName}>
            <thead>
              <tr className=''>
                {field.showRowNumbers && <th>#</th>}
                {field.rowFields.map((f, fieldIndex) => {
                  return (
                    <th key={f.fieldName + fieldIndex} width={f.columnWidth}>
                      {f.label}
                    </th>
                  )
                })}
              </tr>
            </thead>
            {formData[field.fieldName]?.length != 0 && (
              <tbody>
                {(formData[field.fieldName] || field.defaultValue)?.map(
                  (row, rowIndex) => {
                    rowNumber++
                    return (
                      <tr
                        className=''
                        data-input-group-row
                        key={`${field.fieldName}#${rowIndex}`}
                      >
                        {field.showRowNumbers && (
                          <td style={{ width: '20px', fontSize: '10px' }}>
                            {rowNumber}
                          </td>
                        )}

                        {field.rowFields.map((rowField, index) => {
                          let _value =
                            formData?.[field.fieldName]?.[rowIndex][
                              rowField.fieldName
                            ]
                          if (rowField?.mutate) {
                            _value = rowField.mutate(_value)
                          }
                          return (
                            <td key={`${rowField.fieldName}#${index}`}>
                              {_value}
                            </td>
                          )
                        })}
                      </tr>
                    )
                  }
                )}
              </tbody>
            )}
          </table>
        </div>
      </div>
    )
  }

  //get field values from stored formData state
  const loadFieldValueFromSavedFormData = (field, index, parent) => {
    let fieldValue = parent
      ? formData?.[parent][index][field.fieldName]
      : formData?.[field.fieldName]

    if (field.mutate) {
      fieldValue = field.mutate(fieldValue)
    }
    if (formData && mode == 'edit') {
      return fieldValue
    } else if (formData && mode == 'add') {
      return fieldValue || field.defaultValue
    } else {
      return null
    }
  }

  //collect data before submit
  const collectFormData = name => {
    let data = {}
    forms[activeFormIndex]?.fields.forEach((f, index) => {
      if (
        !['readonly-text', 'info-table'].includes(f.type) &&
        f.fieldName != undefined &&
        !f.disabled
      ) {
        if (f.type == 'input-group-row') {
          data[f.fieldName] = getInputRowInputValuesByName(f.fieldName)
        } else if (f.type == 'input-group-section') {
          f.fields.forEach(sectionField => {
            data[sectionField.fieldName] = use.getInputValueByName(
              sectionField.fieldName,
              false,
              document.getElementsByName(name)[0]
            )
          })
        } else {
          data[f.fieldName] = use.getInputValueByName(
            f.fieldName,
            false,
            document.querySelector(`form[name='${name}']`)
          )
        }
      }
    })
    return data
  }

  //get table values during collecting form data
  const getInputRowInputValuesByName = name => {
    let rows = []
    let rowFields = forms[activeFormIndex]?.fields.filter(
      f => f.fieldName == name
    )[0].rowFields

    let inputRows = document.querySelectorAll(
      `form[name="${forms[activeFormIndex].name}"] table[data-table=${name}] tbody tr`
    )
    inputRows.forEach(ir => {
      let row = {}
      rowFields.forEach(rf => {
        if (rf.type != 'operations') {
          row[rf.fieldName] = use.getInputValueByName(rf.fieldName, false, ir)
        }
      })
      rows.push(row)
    })
    return rows
  }

  const collectValidationRules = activeForm => {
    let _validation = {}
    activeForm.fields.forEach(f => {
      if (f.type == 'info-table') {
      } else if (f.type == 'input-group-row') {
        let _rowValidation = {}
        f.rowFields
          .filter(gr => gr.validationRules?.length > 0)
          .forEach(gr => {
            _rowValidation[gr.fieldName] = {
              validationRules: gr.validationRules,
              result: true,
              message: ''
            }
          })
        if (Object.keys(_rowValidation).length > 0) {
          _validation[f.fieldName] = []
          _validation[f.fieldName].push(_rowValidation)
        }
      } else if (f.type == 'input-group-section') {
        f.fields
          .filter(gs => gs.validationRules?.length > 0)
          .forEach(gs => {
            _validation[gs.fieldName] = {
              validationRules: gs.validationRules,
              result: true,
              message: ''
            }
          })
      } else {
        if (f.validationRules?.length > 0) {
          _validation[f.fieldName] = {
            validationRules: f.validationRules,
            result: true,
            message: ''
          }
        }
      }
    })
    return Object.keys(_validation).length > 0 ? _validation : null
  }

  //validate before send data to server
  const validateForm = (data, rules) => {
    
    let _validationResults = {}
    if(rules!=null){
 Object.keys(rules).forEach(field => {
      //validate table
      if (Array.isArray(rules[field])) {
        let tableResult = []
        data[field]?.forEach((row, idx) => {
          let rowResult = {}
          Object.keys(rules[field][0]).forEach(rowField => {
            let _result = null
            _result = ValidateInput(
              rules[field][0][rowField].validationRules,
              row[rowField]
            )
            if (!_result.result) {
              rowResult[rowField] = _result
            }
          })
          if (Object.keys(rowResult).length > 0) {
            rowResult.rowIndex = idx
            tableResult.push(rowResult)
          }
        })
        if (tableResult.length > 0) {
          _validationResults[field] = tableResult
        }
      }
      //validate default field
      else {
        let _result = ValidateInput(rules[field].validationRules, data[field])
        if (!_result.result) {
          _validationResults[field] = _result
        }
      }
    })
    }
   
    setValidation(_validationResults)
    return _validationResults
  }

  //submit the form
  const submitForm = async e => {
    e.preventDefault()
    let activeForm = forms[activeFormIndex]
    const data = collectFormData(activeForm?.name)
    let validationRules = collectValidationRules(activeForm)
    let _validationErrors = validateForm(data, validationRules)
    if (Object.keys(_validationErrors)?.length > 0) {
      return false
    }

    setLoading(true)
    setFormData(data)
    const result = await formSubmitAction(data)

    if (result.success) {
      setFormData(result.data)
      onSubmit()
      if (mode === 'add') {
        navigate(`${moduleUrl}/${result.data.id}`, { replace: true })
      }
      setAlertBoxMessage({
        icon: '/Images/Icons/success.svg',
        type: 'success',
        message: 'Uğurla icra olundu.',
        error: null
      })
    } else {
      setAlertBoxMessage({
        icon: '/Images/Icons/fail.svg',
        type: 'fail',
        message: 'Xəta baş verdi',
        error: result.error?.message
      })
    }
    setTimeout(() => {
      setLoading(false)
    }, 1000)

    setTimeout(() => {
      setAlertBoxMessage({})
    }, 3500)
  }

  const renderAlert = ({ type, message = null, icon = null, error = null }) => {
    let _message = message
    let _icon = `/Images/Icons/${type}.svg`
    if ([undefined, null, ''].includes(_message)) {
      if (type == 'success') {
        _message = 'Uğurla icra olundu!'
      } else {
        _message = `Xəta baş verdi. \n${error}`
      }
    }
    return (
      <div className={`alert-box show ${type}`}>
        <img className='alert-icon' src={_icon} />
        {_message}
      </div>
    )
  }

  //close modal
  const closeModal = () => {
    setFormSubmitAction(null)
    setMode(null)
    setActiveFormIndex(0)
    setOpen(false)
    setFormData({})
    setValidation({})
    navigate(moduleUrl, { replace: true })
  }

  if (forms)
    return (
      <div
        className={`form-modal-container ${open ? 'open' : ''}`}
        onKeyUp={e => {
          if (e.key == 'Escape') {
            closeModal()
          }
        }}
      >
        <div className='alert-container'>
          {Object.keys(alertBoxMessage)?.length > 0 &&
            renderAlert(alertBoxMessage)}
        </div>
        <div className='form-modal'>
          <div className='header'>
            <p className='heading'>{forms[activeFormIndex]?.label}</p>
            <span className='close' onClick={closeModal}>
              &times;
            </span>
          </div>
          <div className='form-tabs'>
            {forms.length > 0 &&
              forms.map((form, index) => {
                return (
                  <Link
                    key={form.name}
                    to={`${moduleUrl}/${id}/${form.name}`}
                    className={`form-tab ${form?.isMain ? 'main' : ''} ${
                      activeFormIndex == index ? 'selected' : ''
                    }`}
                    onClick={e => {
                      if (mode == 'add' && !form?.isStandAlone) {
                        e.preventDefault()
                        alert(
                          `Diqqət! Öncə ${forms[
                            activeFormIndex
                          ]?.label?.toLowerCase()} məlumatları daxil edilməlidir!`
                        )
                        return false
                      } else {
                        if (activeFormIndex != index) {
                          setActiveFormIndex(index)
                        } else {
                          return false
                        }
                      }
                    }}
                  >
                    {form.label}
                  </Link>
                )
              })}
          </div>
          <hr />
          <div className='body'>
            <div className='forms-container'>
              {forms.map((frm, index) => {
                return (
                  <div
                    key={`${frm.name}-${index}`}
                    className='modal-form'
                    style={{
                      display: activeFormIndex == index ? 'flex' : 'none'
                    }}
                  >
                    {renderFormFields(frm, index)}
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    )
}
export default FormModal
